export default "__VITE_ASSET__BldaX2sT__"